import { render } from "./ReportSettings.vue?vue&type=template&id=451ac20c&scoped=true"
import script from "./ReportSettings.vue?vue&type=script&lang=js"
export * from "./ReportSettings.vue?vue&type=script&lang=js"

import "./ReportSettings.vue?vue&type=style&index=0&id=451ac20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451ac20c"]])

export default __exports__